import { render } from "./CabinmanLogoutModal.vue?vue&type=template&id=e8b4fc1c"
import script from "./CabinmanLogoutModal.vue?vue&type=script&lang=js"
export * from "./CabinmanLogoutModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__